export default status => {
  if (status === 'PROCESSING') {
    return '#ffe0b1';
  } if (status === 'SUCCESSFUL') {
    return '#ececff';
  } if (status === 'FAILED') {
    return '#ee6972';
  } return '#ffe0b1';
};
